<template>
    <ac-modal ref="modalRef" :sizeClass="'modal-md'" :title="'Registration Link'">
        <template>
            <div class="row">
                <form class="col-xs-9 col-lg-9">
                    <input ref="regLink" class="form-control" type="text" v-model="registrationLink" readonly>
                </form>
                <div class="col-lg-3">
                    <ac-button class="btn btn-sm btn-green" :action="copyRegLink">Copy URL</ac-button>
                </div>
            </div>
        </template>
    </ac-modal>
</template>

<script>
    import {api} from "../../../global/framework/api.js";

    export default {
        name: "ParticipantWizardLinkModal",
        data() {
            return {
                widgetReady: false,
                registrationLink: ""
            };
        },
        methods: {
            async showModal({companyId, consumerId, userId}) {
                let result = await api.getNoId("Psr", `${companyId}/${consumerId}/getWizardUrl/${userId}`);
                this.registrationLink = result;
                this.widgetReady = true;
                this.$refs.modalRef.open();
            },
            copyRegLink() {
                $(this.$refs.regLink).select();
                document.execCommand("copy");
            },
            closeModal() {
                this.$refs.modalRef.close();
            }
        }

    }
</script>

<style scoped>
    .form-control[readonly] {
        cursor: text;
    }
</style>